import styled from 'styled-components';

import { List, Space, Table } from 'antd';
import { AlertTwoTone } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import {Link, useNavigate} from 'react-router-dom';
import moment from 'moment';

import {NewPullRequestIcon, UserIcon, DateIcon, TypeIcon, CompanyIcon} from '../icons';
import {AlertTag} from "./AlertTag";
import companyIcon from '../assets/images/icons/company@2x.png';
import { CustomMoreLink } from './Common';

const TableContainer = styled.div`
  // margin-bottom: 20px;
  overflow: hidden;
`;

export const CardTitle = styled.div`
  position: relative;
  font-size: 18px;
  line-height: 18px;
  margin-top: 20px;
  font-weight: 600;
  color: #fff;
`;

const FlexCenter = styled.div`
  display: flex;
  align-items: center;
`
const CompanyIconWrap = styled(FlexCenter)`
  img {
    margin-right: 3px;
  }
`

const CustomLink = styled(Link)`
  color: #4B555E;
  font-size: 12px;
  line-height: 18px;
  &:hover{
    color:#6ee6c6;
  }
`

const CommonTable = ({ data, loading, title, pagination }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <TableContainer>
      {title ? <CardTitle>{title} 
      <div style={{
        float:'right',
        fontSize: '14px'
      }}>
        
        <CustomMoreLink
            to={`/reports`}
          >
            + more
        </CustomMoreLink>
        </div>
      </CardTitle> : null}
      
      <List
        className="report-list"
        itemLayout="horizontal"
        loading={loading}
        bordered={false}
        dataSource={data}
        pagination={pagination}
        split={true}
        renderItem={(item, index) => (
          <List.Item style={{padding: '16px 0'}}>
            <List.Item.Meta
              avatar={null}
              title={
                <div
                  onClick={() => {
                    navigate(`/reports/${item.serial_number}`)
                  }}
                  style={{
                    color: '#fff',
                    fontSize: '14px',
                    lineHeight: '26px',
                    fontWeight: '700',
                    cursor: 'pointer',
                    fontFamily: 'HelveticaNeueBold'
                  }}
                  className="report-list-title"
                >
                  {item.title}
                </div>
              }
              description={
                <div
                  style={{
                    color: '#4B555E',
                  }}
                >
                  <Space size={28}>
                        <AlertTag type={item.level_id} height={25} space={2} />
                        <CompanyIconWrap>
                            <img width={11} height={11} src={companyIcon} />
                              <CustomLink to={ item.company_name ? `/bounties/${item.company_name}` : ''} reloadDocument className="home-report-company">
                                  {item.company_name}
                              </CustomLink>
                        </CompanyIconWrap>
                      {/*<CompanyIcon companyName={item.company_name} />*/}
                      <FlexCenter>
                          <UserIcon />
                          <CustomLink to={`/whiteHats/${item.user.name}`} className="home-report-user">
                            {item.user.name}
                          </CustomLink>
                      </FlexCenter>
                      <FlexCenter className="home-report-date">
                        <DateIcon />
                        <span
                          style={{
                            fontSize: '12px',
                            lineHeight: '18px',
                          }}
                        >
                          {moment.unix(item.created_at).format('YYYY-MM-DD')}
                        </span>
                      </FlexCenter>
                  </Space>
                </div>
              }
            />
          </List.Item>
        )}
      />
    </TableContainer>
  );
};

export default CommonTable;
